module.exports = __webpack_public_path__ + "media/images/app/trust/iconThree-6e0ebf2d43aff0eb29709659e36ad527.webp";